<template>
    <div class="chat-page">
      <!-- 头部 -->
      <div class="chat-header">
        <el-button type="text" icon="el-icon-arrow-left" @click="goBack"></el-button>
        <span class="header-title">返回</span>
      </div>
  
      <!-- 聊天内容区域 -->
      <div class="chat-content">
        <div
          v-for="(message, index) in messages"
          :key="index"
          :class="['message', message.sender === 'me' ? 'my-message' : 'other-message']"
        >
          <div class="message-content">
            {{ message.content }}
          </div>
        </div>
      </div>
  
      <!-- 输入框区域 -->
      <div class="chat-input">
        <el-input
          v-model="inputMessage"
          placeholder="请输入消息"
          @keyup.enter="sendMessage"
        ></el-input>
        <el-button type="primary" @click="sendMessage">发送</el-button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        inputMessage: "", // 输入框内容
        messages: [
          { sender: "other", content: "你好！" },
          { sender: "me", content: "你好，有什么可以帮你的吗？" },
          { sender: "other", content: "我想了解一下你们的产品。" },
        ], // 消息列表
      };
    },
    methods: {
      // 发送消息
      sendMessage() {
        if (this.inputMessage.trim() === "") return; // 空消息不发送
        this.messages.push({ sender: "me", content: this.inputMessage }); // 添加到消息列表
        this.inputMessage = ""; // 清空输入框
  
        // 模拟对方回复
        setTimeout(() => {
          this.messages.push({ sender: "other", content: "好的，请稍等。" });
        }, 1000);
      },
      // 返回上一页
      goBack() {
        this.$router.go(-1);
      },
    },
  };
  </script>
  
  <style scoped>
  .chat-page {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #f5f5f5;
  }
  
  /* 头部样式 */
  .chat-header {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background-color: #409eff;
    color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .chat-header .el-button {
    color: white;
    font-size: 18px;
  }
  
  .header-title {
    margin-left: 10px;
    font-size: 18px;
    font-weight: bold;
  }
  
  /* 聊天内容区域 */
  .chat-content {
    flex: 1;
    padding: 15px;
    overflow-y: auto;
    background-color: #f5f5f5;
  }
  
  /* 消息样式 */
  .message {
    margin-bottom: 15px;
    display: flex;
  }
  
  .message-content {
    max-width: 70%;
    padding: 10px 15px;
    border-radius: 8px;
    word-wrap: break-word;
    font-size: 14px;
  }
  
  /* 我的消息 */
  .my-message {
    justify-content: flex-end;
  }
  
  .my-message .message-content {
    background-color: #409eff;
    color: white;
    border-radius: 8px 8px 0 8px;
  }
  
  /* 对方的消息 */
  .other-message {
    justify-content: flex-start;
  }
  
  .other-message .message-content {
    background-color: #ffffff;
    color: #333;
    border-radius: 8px 8px 8px 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  
  /* 输入框区域 */
  .chat-input {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background-color: white;
    border-top: 1px solid #ddd;
  }
  
  .chat-input .el-input {
    flex: 1;
    margin-right: 10px;
  }
  
  .chat-input .el-button {
    padding: 10px 20px;
  }
  </style>